import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { HelpCircle } from "lucide-react";

/**
 * Floating "Need help?" pill — appears on every in-app page (/app/*) except
 * the Tutorial page itself. Tapping it routes the user to /app/tutorial.
 *
 * Anchored bottom-left to stay out of the way of the Spotify pill (bottom-right)
 * and the mobile bottom nav (which hugs the bottom of the viewport on md-).
 */
export default function HelpButton() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const isInApp = pathname.startsWith("/app/");
  const isOnTutorial = pathname.startsWith("/app/tutorial");
  if (!isInApp || isOnTutorial) return null;

  return (
    <button
      type="button"
      onClick={() => navigate("/app/tutorial")}
      className="hidden md:flex fixed bottom-6 left-6 z-40 group items-center gap-2 bg-[#121212] border border-white/15 hover:border-[#6B9BFF] text-white/70 hover:text-[#6B9BFF] px-4 py-2.5 shadow-lg transition-colors"
      style={{ borderRadius: 9999 }}
      data-testid="help-floating-button"
      aria-label="Open tutorial"
    >
      <HelpCircle className="w-4 h-4" />
      <span className="text-xs font-bold uppercase tracking-widest">
        Need help?
      </span>
    </button>
  );
}
